import { render } from "./NotificationsView.vue?vue&type=template&id=4569b9ee&scoped=true"
import script from "./NotificationsView.vue?vue&type=script&lang=js"
export * from "./NotificationsView.vue?vue&type=script&lang=js"

import "./NotificationsView.vue?vue&type=style&index=0&id=4569b9ee&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4569b9ee"]])

export default __exports__